import { graphql, type ResultOf } from 'gql.tada'

import type { GqlClient } from '@/types/gqlClient'

// "Changer le commercial" (#769) — the transport half.
//
// A Hasura Action, not an `update_projects_by_pk` / `update_urban_analysis_by_pk`
// from here: the study table's update permission carries
// `set: { status: EDITED }`, so reassigning a VALIDATED study through it would
// withdraw the report that was already generated and mailed. The server also
// re-checks who may hand a dossier to whom, which no frontend can do.

export type ChangeSalesmanTarget =
  | { projectId: number; urbanAnalysisId?: undefined }
  | { urbanAnalysisId: number; projectId?: undefined }


export const ChangeSalesmanDocument = graphql(`
  mutation ChangeSalesman(
    $project_id: Int
    $urban_analysis_id: Int
    $salesman_id: Int!
  ) {
    change_salesman(
      project_id: $project_id
      urban_analysis_id: $urban_analysis_id
      salesman_id: $salesman_id
    ) {
      salesman_id
      project_id
      urban_analysis_id
      updated_studies
    }
  }
`)

/** What the action answers with, inferred from the document itself. */
export type ChangeSalesmanResult = NonNullable<
  ResultOf<typeof ChangeSalesmanDocument>['change_salesman']
>

export const changeSalesman = (
  gqlClient: GqlClient,
  target: ChangeSalesmanTarget,
  salesmanId: number,
): Promise<ResultOf<typeof ChangeSalesmanDocument>> =>
  gqlClient.request(ChangeSalesmanDocument, {
    // Exactly one is sent; the other is an explicit null, which the action's
    // Zod schema reads as "not this resource" rather than a malformed call.
    project_id: target.projectId ?? null,
    urban_analysis_id: target.urbanAnalysisId ?? null,
    salesman_id: salesmanId,
  })
